import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import { Breadcrumbs, Classes, Icon, Intent, ITreeNode, Tree } from "@blueprintjs/core";
import { Example, IExampleProps } from "@blueprintjs/docs-theme";
import { Tooltip2 } from "@blueprintjs/popover2";
import StarLabel from '../component/StarLabel';

export interface ITreeExampleState {
    nodes: ITreeNode[];
}

@inject("store")
@observer
export default class Sidebar extends  React.Component<IExampleProps, ITreeExampleState>
{
    
    constructor(props) {
        super(props);
        const INITIAL_STATE: ITreeNode[] = [
            {
                id: 0,
                hasCaret: true,
                icon: "folder-close",
                label: "小故事：从零开始写故事",
                isExpanded: true,
                childNodes: [
                    {
                        id: 1,
                     
                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                        label: "简要介绍",
                    },
                    {
                        id: 2,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "人物",
                        childNodes: [
                            {
                                id: 3,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "人物夙愿",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[0,1,0]}/>
                                    ),
                              
                            
                            },
                            {
                                id: 4,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "格格不入",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[0,1,1]}/>
                                    ),
                            
                            },
                            {
                                id: 5,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "敌对关系",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[0,1,2]}/>
                                    ),
                            
                            },

                            {
                                id: 6,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "爱而不得",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[0,1,3]}/>
                                    ),
                            
                            },


                        ],
                    
                    },
                    {
                        id: 3,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "情节",
                        childNodes: [
                            {
                                id: 4,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "忽起变化",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[0,2,0]}/>
                                    ),
                            
                            },
                            {
                                id: 5,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "寻宝故事",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[0,2,1]}/>
                                    ),
                            
                            },

                            {
                                id: 6,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "未解之谜",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[0,2,2]}/>
                                    ),
                            
                            },

                            {
                                id: 7,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "如愿以偿",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[0,2,3]}/>
                                    ),
                            
                            },

                            {
                                id: 8,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "天降横祸",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[0,2,4]}/>
                                    ),
                            
                            },

                          
                        ],
                    },

                    {
                        id: 4,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "环境",

                        childNodes: [
                            {
                                id: 5,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "临近崩塌",
                            
                            },

                            {
                                id: 6,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "入侵破坏",
                            
                            },

                            {
                                id: 7,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "屋中怪物",
                            
                            },

                            {
                                id: 8,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "竞技赛场",
                            
                            },


                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "异国他乡",
                            
                            },

                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "乌合之众",
                            
                            },
                        ],
                    },

                    {
                        id: 5,
                     
                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                        label: "三题作文",
                        secondaryLabel:(
                            <StarLabel labelname = "三题作文" notepath = {[0,4]}/>
                            ),
                    },

                    {
                        id: 6,
                     
                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                        label: "随机轻小说练习",
                        secondaryLabel:(
                            <StarLabel labelname = "三题作文" notepath = {[0,5]}/>
                            ),
                    },

                    {
                        id: 7,
                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                        label: "戏剧化开头",
                        secondaryLabel:(
                            <StarLabel labelname = "三题作文" notepath = {[0,6]}/>
                            ),
                    },
                    
                ],
            },
            {
                id: 1,
                icon: "folder-close",
                label: "文笔篇：词汇，描写练习",
                childNodes: [
                    {
                        id: 2,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "场景描写",
                        childNodes: [
                            {
                                id: 3,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 4,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "场景摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,0,1]}/>
                                    ),
                            },

                            {
                                id: 5,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "场景仿写",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,0,2]}/>
                                    ),
                            },

                            {
                                id: 6,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "场景练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,0,3]}/>
                                    ),
                            },

                            {
                                id: 7,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素判断",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,0,4]}/>
                                    ),
                            },

                            {
                                id: 8,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素增减",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,0,5]}/>
                                    ),
                            },

                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "顺序判断",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,0,6]}/>
                                    ),
                            },

                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "更改顺序",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,0,7]}/>
                                    ),
                            },

                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "场景切换",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,0,8]}/>
                                    ),
                            },
                        ],
                    },
                    {
                        id: 3,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "外貌描写",
                        childNodes: [
                            {
                                id: 4,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },

                            {
                                id: 6,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "外貌摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,1,1]}/>
                                    ),
                            },

                            {
                                id: 7,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "外貌仿写",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,1,2]}/>
                                    ),
                            },
                            {
                                id: 8,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "外貌练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,1,3]}/>
                                    ),
                            },

                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素判断",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,1,4]}/>
                                    ),
                            },

                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素增减",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,1,5]}/>
                                    ),
                            },

                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "特征选择",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,1,6]}/>
                                    ),
                            },

                            {
                                id: 12,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "群像描写",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,1,7]}/>
                                    ),
                            },
                        ],
                    },
                    {
                        id: 4,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "服饰描写",

                        childNodes: [
                            {
                                id: 5,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 6,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "服饰摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,2,1]}/>
                                    ),
                            },
                            {
                                id: 7,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "服饰仿写",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,2,2]}/>
                                    ),
                            },
                            {
                                id: 8,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "服饰练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,2,3]}/>
                                    ),
                            },

                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "配件搭配",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,2,4]}/>
                                    ),
                            },

                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素判断",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,2,5]}/>
                                    ),
                            },

                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素增减",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,2,6]}/>
                                    ),
                            },

                            {
                                id: 12,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "区别身份",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,2,7]}/>
                                    ),
                            },

                            {
                                id: 13,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "区别场合",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,2,8]}/>
                                    ),
                            },

                            {
                                id: 14,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "塑造人物",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,2,9]}/>
                                    ),
                            },

                            {
                                id: 15,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "体现风格",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,2,10]}/>
                                    ),
                            },

                        ],
                    },

                    {
                        id: 5,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "战斗描写",
                        childNodes: [
                            {
                                id: 6,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },

                            {
                                id: 7,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "战斗摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,3,1]}/>
                                    ),
                            },

                            {
                                id: 8,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "战斗仿写",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,3,2]}/>
                                    ),
                            },

                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "战斗练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,3,3]}/>
                                    ),
                            },

                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素判断",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,3,4]}/>
                                    ),
                            },

                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素增减",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,3,5]}/>
                                    ),
                            },

                            {
                                id: 12,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "战斗速度",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,3,6]}/>
                                    ),
                            },

                            {
                                id: 13,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "速度更改",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,3,7]}/>
                                    ),
                            },

                            {
                                id: 14,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "虚实判断",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,3,8]}/>
                                    ),
                            },

                            {
                                id: 15,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "虚实选择",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,3,9]}/>
                                    ),
                            },

                            {
                                id: 16,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "转场判断",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,3,10]}/>
                                    ),
                            },

                            {
                                id: 17,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "转场练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,3,11]}/>
                                    ),
                            },
                        ],

                    },

                    {
                        id: 6,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "心理描写",
                        childNodes: [

                            {
                                id: 7,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },

                            {
                                id: 8,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "心理摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,4,1]}/>
                                    ),
                            },

                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "心理仿写",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,4,2]}/>
                                    ),
                            },

                           

                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "情绪类型",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,4,3]}/>
                                    ),
                            },

                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "心理练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,4,4]}/>
                                    ),
                            },

                            {
                                id: 12,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素判断",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,4,5]}/>
                                    ),
                            },


                            {
                                id: 13,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素增减",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,4,6]}/>
                                    ),
                            },

                           
                        ],

                    },

                    {
                        id: 7,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "展示",
                        childNodes: [
                            {
                                id: 8,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "展示判断",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,5,1]}/>
                                    ),
                            },
                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "展示练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,5,2]}/>
                                    ),
                            },

                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "展示选择",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,5,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 8,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "对话",
                        childNodes: [
                            {
                                id: 9,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "偷听工程",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,6,1]}/>
                                    ),
                            },
                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "对话练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,6,2]}/>
                                    ),
                            },

                            {
                                id: 12,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "口语练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,6,3]}/>
                                    ),
                            },

                            {
                                id: 13,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "对话精炼",
                                 secondaryLabel:(
                                    <StarLabel  notepath = {[1,6,4]}/>
                                    ),
                            },
                        ],

                    },

                    {
                        id: 9,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "画面感",
                        childNodes: [
                            {
                                id: 10,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "画面练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,7,1]}/>
                                    ),
                            },

                            {
                                id: 12,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "色彩练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,7,2]}/>
                                    ),
                            },

                            {
                                id: 13,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "形状练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,7,3]}/>
                                    ),
                            },

                            {
                                id: 14,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "光影练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,7,4]}/>
                                    ),
                            },

                            {
                                id: 15,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "画面选择",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,7,5]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 10,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "叙事",
                        childNodes: [
                            {
                                id: 11,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 12,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素分辨",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,8,1]}/>
                                    ),
                            },

                            {
                                id: 13,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "单纯讲事",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,8,2]}/>
                                    ),
                            },

                            {
                                id: 14,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "要素增减",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,8,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 11,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "节奏",
                        childNodes: [
                            {
                                id: 12,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 13,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "音长分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,9,1]}/>
                                    ),
                            },

                            {
                                id: 14,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "音强分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,9,2]}/>
                                    ),
                            },

                            {
                                id: 15,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "案例模仿",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,9,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 12,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "象征",
                        childNodes: [
                            {
                                id: 13,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 14,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "象征练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[1,10,1]}/>
                                    ),
                            },

                           
                        ],
                    },
                ],
            },
            {
                id: 2,
                hasCaret: true,
                icon: "folder-close",
                label: "套路篇：情节片段与情绪调动",
                childNodes: [
                    {
                        id: 3,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "爽文套路",
                        childNodes: [
                            {
                                id: 4,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "爽文概述",
                            },
                            {
                                id: 5,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "显摆",
                                childNodes: [
                                    {
                                        id: 6,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 7,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "显摆摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,1,1]}/>
                                            ),
                                       
                                    },
                                    {
                                        id: 8,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "显摆仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,1,2]}/>
                                            ),
                                       
                                    },
                                    {
                                        id: 9,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "显摆练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,1,3]}/>
                                            ),
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 6,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "获得",
                                childNodes: [
                                    {
                                        id: 7,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 8,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "获得摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,2,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 9,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "获得仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,2,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 10,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "获得练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,2,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 7,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "打脸",
                                childNodes: [
                                    {
                                        id: 8,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 9,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "打脸摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,3,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 10,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "打脸仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,3,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 11,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "打脸练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,3,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 8,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "英雄救美",
                                childNodes: [
                                    {
                                        id: 9,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 10,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "英雄救美摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,4,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 11,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "英雄救美仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,4,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 12,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "英雄救美练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,4,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 9,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "两虎相争",
                                childNodes: [
                                    {
                                        id: 10,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 11,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "两虎相争摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,5,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 12,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "两虎相争仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,5,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 13,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "两虎相争练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,5,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 10,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "预言",
                                childNodes: [
                                    {
                                        id: 11,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 12,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "预言摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,6,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 13,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "预言仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,6,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 14,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "预言练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,6,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 11,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "密谋",
                                childNodes: [
                                    {
                                        id: 12,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 13,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "密谋摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,7,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 14,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "密谋仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,7,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 15,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "密谋练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,7,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 12,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "赌注",
                                childNodes: [
                                    {
                                        id: 13,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 14,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "赌注摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,8,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 15,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "赌注仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,8,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 16,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "赌注练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,8,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 13,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "冤枉",
                                childNodes: [
                                    {
                                        id: 14,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 15,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "冤枉摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,9,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 16,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "冤枉仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,9,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 17,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "冤枉练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,9,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 14,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "经典铺垫",
                                childNodes: [
                                    {
                                        id: 15,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 16,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "经典铺垫摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,10,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 17,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "经典铺垫仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,10,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 18,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "经典铺垫练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,10,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 15,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "站上舞台",
                                childNodes: [
                                    {
                                        id: 16,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 17,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "站上舞台摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,11,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 18,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "站上舞台仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,11,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 19,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "站上舞台练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,11,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 16,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "预先提名",
                                childNodes: [
                                    {
                                        id: 17,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 18,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "预先提名摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,12,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 19,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "预先提名仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,12,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 20,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "预先提名练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,12,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 17,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "先败为敬",
                                childNodes: [
                                    {
                                        id: 18,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 19,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "先败为敬摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,13,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 20,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "先败为敬仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,13,2]}/>
                                            ),
                                        
                                        
                                       
                                    },
                                    {
                                        id: 21,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "先败为敬练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,13,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 18,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "倒计时",
                                childNodes: [
                                    {
                                        id: 19,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 20,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "倒计时摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,14,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 21,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "倒计时仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,14,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 22,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "倒计时练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,14,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 19,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "反常",
                                childNodes: [
                                    {
                                        id: 20,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 21,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "反常摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,15,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 22,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "反常仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,15,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 23,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "反常练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,15,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 20,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "表态",
                                childNodes: [
                                    {
                                        id: 21,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 22,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "表态摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,16,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 23,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "表态仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,16,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 24,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "表态练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,16,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 21,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "征服",
                                childNodes: [
                                    {
                                        id: 22,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 23,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "征服摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,17,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 24,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "征服仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,17,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 25,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "征服练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,17,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 22,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "扮猪吃虎",
                                childNodes: [
                                    {
                                        id: 23,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 24,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "扮猪吃虎摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,18,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 25,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "扮猪吃虎仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,18,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 26,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "扮猪吃虎练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,18,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 23,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "陷入危机+神器认主",
                                childNodes: [
                                    {
                                        id: 24,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 25,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "神器认主摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,19,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 26,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "神器认主仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,19,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 27,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "神器认主练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,19,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 24,
                                hasCaret: true,
                                icon: <Icon icon="folder-close" className={Classes.TREE_NODE_ICON} />,
                                label: "跌入谷底+明星聚光",
                                childNodes: [
                                    {
                                        id: 25,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 26,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "明星聚光摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,20,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 27,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "明星聚光仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,20,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 28,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "明星聚光练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,0,20,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },

                           
                        ],
                    },
                    {
                        id: 4,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "言情套路",
                        childNodes: [
                            {
                                id: 5,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "言情概述",
                            },
                            {
                                id: 6,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "在意",
                                childNodes: [
                                    {
                                        id: 7,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 8,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "在意摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,1,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 9,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "在意仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,1,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 10,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "在意练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,1,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 7,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "欣赏",
                                childNodes: [
                                    {
                                        id: 8,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 9,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "欣赏摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,2,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 10,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "欣赏仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,2,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 11,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "欣赏练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,2,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 8,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "长情",
                                childNodes: [
                                    {
                                        id: 9,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 10,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "长情摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,3,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 11,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "长情仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,3,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 12,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "长情练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,3,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                                
                            },
                            {
                                id: 9,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "竞争",
                                childNodes: [
                                    {
                                        id: 10,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 11,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "竞争摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,4,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 12,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "竞争仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,4,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 13,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "竞争练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,4,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 10,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "吹嘘",
                                childNodes: [
                                    {
                                        id: 11,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 12,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "吹嘘摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,5,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 13,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "吹嘘仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,5,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 14,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "吹嘘练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,5,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 11,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "占有欲",
                                childNodes: [
                                    {
                                        id: 12,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 13,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "占有欲摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,6,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 14,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "占有欲仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,6,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 15,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "占有欲练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,6,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 12,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "言情英雄救美",
                                childNodes: [
                                    {
                                        id: 13,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 14,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "言情英雄救美摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,7,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 15,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "言情英雄救美仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,7,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 16,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "言情英雄救美练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,7,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 13,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "共度危机",
                                childNodes: [
                                    {
                                        id: 14,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 15,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "共度危机摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,8,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 16,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "共度危机仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,8,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 17,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "共度危机练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,8,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 14,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "禁忌",
                                childNodes: [
                                    {
                                        id: 15,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 16,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "禁忌摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,9,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 17,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "禁忌仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,9,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 18,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "禁忌练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,9,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 15,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "契约",
                                childNodes: [
                                    {
                                        id: 16,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 17,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "契约摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,10,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 18,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "契约仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,10,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 19,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "契约练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,10,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 16,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "误会",
                                childNodes: [
                                    {
                                        id: 17,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 18,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "误会摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,11,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 19,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "误会仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,11,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 20,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "误会练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,11,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 17,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "秘密",
                                childNodes: [
                                    {
                                        id: 18,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 19,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "秘密摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,12,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 20,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "秘密仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,12,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 21,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "秘密练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,12,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 18,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "黯然神伤",
                                childNodes: [
                                    {
                                        id: 19,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 20,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "黯然神伤摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,13,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 21,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "黯然神伤仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,13,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 22,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "黯然神伤练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,13,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 19,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "牺牲",
                                childNodes: [
                                    {
                                        id: 20,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 21,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "牺牲摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,14,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 22,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "牺牲仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,14,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 23,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "牺牲练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,14,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 20,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "神秘",
                                childNodes: [
                                    {
                                        id: 21,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 22,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "神秘摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,15,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 23,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "神秘仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,15,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 24,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "神秘练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,15,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 21,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "身体接触",
                                childNodes: [
                                    {
                                        id: 22,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 23,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "身体接触摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,16,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 24,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "身体接触仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,16,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 25,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "身体接触练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,16,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 22,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "告白",
                                childNodes: [
                                    {
                                        id: 23,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 24,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "告白摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,17,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 25,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "告白仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,17,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 26,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "告白练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,17,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 23,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "失而复得",
                                childNodes: [
                                    {
                                        id: 24,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 25,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "失而复得摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,18,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 26,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "失而复得仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,18,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 27,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "失而复得练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,18,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 24,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "意料之外",
                                childNodes: [
                                    {
                                        id: 25,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 26,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "意料之外摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,19,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 27,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "意料之外仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,19,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 28,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "意料之外练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,19,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                            {
                                id: 25,
                                hasCaret: true,
                                icon: <Icon icon="folder-close"  className={Classes.TREE_NODE_ICON} />,
                                label: "对你与众不同",
                                childNodes: [
                                    {
                                        id: 26,
                                        icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                        label: "理论讲解",
                                    },
                                    {
                                        id: 27,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "对你与众不同摘抄",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,20,1]}/>
                                            ),
                                       
                                       
                                    },
                                    {
                                        id: 28,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "对你与众不同仿写",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,20,2]}/>
                                            ),
                                        
                                       
                                    },
                                    {
                                        id: 29,
                                        icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                        label: "对你与众不同练习",
                                        secondaryLabel:(
                                            <StarLabel  notepath = {[2,1,20,3]}/>
                                            ),
                                       
                                       
                                    },
        
                                   
                                ],
                                
                            },
                        ],
                    },

                    {
                        id: 5,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "恐惧情绪",
                        childNodes: [
                            {
                                id: 6,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 7,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "恐惧摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,2,1]}/>
                                    ),
                            },
                            {
                                id: 8,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "恐惧分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,2,2]}/>
                                    ),
                            },
                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "恐惧练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,2,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 6,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "愤怒情绪",
                        childNodes: [
                            {
                                id: 7,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 8,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "愤怒摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,3,1]}/>
                                    ),
                            },
                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "愤怒分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,3,2]}/>
                                    ),
                            },
                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "愤怒练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,3,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 7,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "泪点",
                        childNodes: [
                            {
                                id: 8,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "泪点摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,4,1]}/>
                                    ),
                            },
                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "泪点分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,4,2]}/>
                                    ),
                            },
                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "泪点练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,4,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 8,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "笑点",
                        childNodes: [
                            {
                                id: 9,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "笑点摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,5,1]}/>
                                    ),
                            },
                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "笑点分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,5,2]}/>
                                    ),
                            },
                            {
                                id: 12,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "笑点练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[2,5,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 9,
                        icon:  <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                        label: "套路概述",
                    },
                ],
            },

            {
                id: 3,
                hasCaret: true,
                icon: "folder-close",
                label: "结构篇：故事进阶技巧",
                childNodes: [
                    {
                        id: 4,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "事件",
                        childNodes: [
                            {
                                id: 5,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 6,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "事件分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,0,1]}/>
                                    ),
                            },
                            {
                                id: 7,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "事件写作",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,0,2]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 5,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "故事线",
                        childNodes: [
                            {
                                id: 6,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 7,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "故事线归纳",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,1,1]}/>
                                    ),
                            },

                            {
                                id: 8,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "故事线分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,1,2]}/>
                                    ),
                            },

                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "故事线写作",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,1,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 6,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "人物功能",
                        childNodes: [
                            {
                                id: 7,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 8,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "功能收集",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,2,1]}/>
                                    ),
                            },

                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "功能分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,2,2]}/>
                                    ),
                            },

                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "人物设定",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,2,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 7,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "代入感",
                        childNodes: [
                            {
                                id: 8,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 9,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "人物收集",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,3,1]}/>
                                    ),
                            },

                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "人物分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,3,2]}/>
                                    ),
                            },

                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "人物设定",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,3,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 8,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "人称与视角",
                        childNodes: [
                            {
                                id: 9,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                              
                            },
                            {
                                id: 10,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "视角分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,4,1]}/>
                                    ),
                            },

                            {
                                id: 11,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "视角更改",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,4,2]}/>
                                    ),
                            },
                        ],

                    },

                    {
                        id: 9,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "对话",
                        childNodes: [
                        {
                            id: 10,
                            icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                            label: "理论讲解",
                        },

                        {
                            id: 12,
                            icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                            label: "作用分析",
                            secondaryLabel:(
                                <StarLabel  notepath = {[3,5,1]}/>
                                ),
                        },

                        {
                            id: 13,
                            icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                            label: "潜台词",
                            secondaryLabel:(
                                <StarLabel  notepath = {[3,5,2]}/>
                                ),
                        },

                        {
                            id: 14,
                            icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                            label: "问题诊断",
                            secondaryLabel:(
                                <StarLabel  notepath = {[3,5,3]}/>
                                ),
                        },


                    ],

                    },

                    {
                        id: 10,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "冲突",
                        childNodes: [
                            {
                                id: 11,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 12,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "冲突分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,6,1]}/>
                                    ),
                            },

                            {
                                id: 13,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "增加冲突",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,6,2]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 11,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "开头",
                        childNodes: [
                            {
                                id: 12,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 13,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "开头摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,7,1]}/>
                                    ),
                            },

                            {
                                id: 14,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "开头分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,7,2]}/>
                                    ),
                            },

                            {
                                id: 15,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "开头仿写",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,7,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 12,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "铺垫",
                        childNodes: [
                            {
                                id: 13,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },

                            {
                                id: 14,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "铺垫摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,8,1]}/>
                                    ),
                            },
                            {
                                id: 15,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "铺垫分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,8,2]}/>
                                    ),
                            },

                            {
                                id: 16,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "铺垫练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,8,3]}/>
                                    ),
                            },
                        ],

                    },

                   
                    {
                        id: 13,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "反常",
                        childNodes: [
                            {
                                id: 14,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },

                            {
                                id: 15,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "反常摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,9,1]}/>
                                    ),
                            },
                            {
                                id: 16,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "反常分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,9,2]}/>
                                    ),
                            },

                            {
                                id: 17,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "反常练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,9,3]}/>
                                    ),
                            },
                        ],

                    },

                    {
                        id: 14,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "悬疑",
                        childNodes: [
                            {
                                id: 15,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 16,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "悬疑摘抄",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,10,1]}/>
                                    ),
                            },
                            {
                                id: 17,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "悬疑分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,10,2]}/>
                                    ),
                            },
                            {
                                id: 18,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "悬疑设置",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,10,3]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 15,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "节奏",
                        childNodes: [
                            {
                                id: 16,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 17,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "节奏分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,11,1]}/>
                                    ),
                            },
                            {
                                id: 18,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "节奏仿写",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,11,2]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 16,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "鸿沟",
                        childNodes: [
                            {
                                id: 17,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 18,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "鸿沟分析",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,12,1]}/>
                                    ),
                            },
                            {
                                id: 19,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "鸿沟练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,12,2]}/>
                                    ),
                            },
                        ],
                    },

                    {
                        id: 17,
                        hasCaret: true,
                        icon: "folder-close",
                        label: "信息扣押",
                        childNodes: [
                            {
                                id: 18,
                                icon: <Icon icon="document" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
                                label: "理论讲解",
                            },
                            {
                                id: 19,
                                icon: <Icon icon="annotation" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
                                label: "扣押练习",
                                secondaryLabel:(
                                    <StarLabel  notepath = {[3,13,1]}/>
                                    ),
                            },
                        ],
                    },
                ],
            },

          
        ];
        
        this.state = { nodes: INITIAL_STATE,"changing":1 };
        this.handleNodeClick = this.handleNodeClick.bind(this);
        this.handleNodeCollapse = this.handleNodeCollapse.bind(this);
        this.handleNodeExpand =  this.handleNodeExpand.bind(this);
    
      }

      forEachNode(nodes: ITreeNode[], callback: (node: ITreeNode) => void) {
        if (nodes == null) {
            return;
        }

        for (const node of nodes) {
            callback(node);
            this.forEachNode(node.childNodes, callback);
        }
    }

      handleNodeClick(nodeData: ITreeNode, _nodePath: number[], e: React.MouseEvent<HTMLElement>){
            const originallySelected = nodeData.isSelected;
            if (!e.shiftKey) {
               this.forEachNode(this.state.nodes, n => (n.isSelected = false));
            }
            nodeData.isSelected = originallySelected == null ? true : !originallySelected;
         
            this.setState(this.state);
            this.props.store.nodepath = _nodePath;
           this.props.store.appname = _nodePath;
         //  this.props.store.appname = nodeData.label;
      

            //改变nodelist
           /* if( _nodePath[0] ==0 && _nodePath[1] ==4 ){
                this.props.store.current_note_list = [
                    {name:"狡猾，泳装，鲁迅全集",id:1},
                    {name:"2222",id:2}
                ];

                if( this.props.store.view_type == 1 ) this.props.store.view_type = 2;
              }*/
             //改变notelist里面的数组
                this.props.store.getnotelistitem(_nodePath);
             
             
                if(this.props.store.current_note_list!=null){
                    if(this.props.store.current_note_list.length!=0){
                        if( this.props.store.view_type == 1 ) this.props.store.view_type = 2;
                      }
                }
              


            //直接改变nodepage
           this.props.store.getnotepagechange(_nodePath);

      };

     

  
   

       handleNodeCollapse(nodeData: ITreeNode){
        nodeData.isExpanded = false;
        this.setState(this.state);
     
    };

     handleNodeExpand(nodeData: ITreeNode){
        nodeData.isExpanded = true;
       this.setState(this.state);
    };

   

    render()
    {
        

        return  <div className = "sidebar">
        
            <Example options={false} {...this.props}>
                <Tree
                    contents={this.state.nodes}
                    onNodeClick={this.handleNodeClick}
                    onNodeCollapse={this.handleNodeCollapse}
                    onNodeExpand={this.handleNodeExpand}
                    className={Classes.ELEVATION_0}
                />
            </Example>
     
    
    
    </div>
    }
}